import Axios from '../../../extra-functions/axios.extra.js'
import store from '../../../store'
import { errorHandler } from '../../../extra-functions/store.extra'

const axios = Axios(store.state.auth.token)

const storeUser = {
  data() {
    return {
      mxStoringUser: false,
      mxStoreUserErrors: [],
    }
  },
  methods: {
    mxStoreUser(data, success) {
      this.mxStoreUserErrors = []
      if (!this.mxStoringgUser) {
        this.mxStoringUser = true
        axios.post('admin/users', data)
          .then(({ data }) => {
            success(data)
          }).catch(errors => {
            this.mxStoreUserErrors = errorHandler(errors)
          }).then(() => {
            this.mxStoringUser = false
          })
      }
    },
  },
}

const updateUser = {
  data() {
    return {
      mxUpdatingUser: false,
      mxUpdateUserErrors: [],
    }
  },
  methods: {
    mxUpdateUser(id, data, success) {
      this.mxUpdateUserErrors = []
      if (!this.mxUpdatingUser) {
        this.mxUpdatingUser = true
        return axios.put(`admin/users/${id}`, data)
          .then(({ data }) => {
            success(data)
          }).catch(errors => {
            this.mxUpdateUserErrors = errorHandler(errors)
          }).then(() => {
            this.mxUpdatingUser = false
          })
      }
    },
  },
}

const fetchUsers = {
  data() {
    return {
      mxUsers: [],
      mxTotalUsers: 0,
      mxFetchingUsers: false,
      mxUserFetchErrors: [],
    }
  },
  methods: {
    mxFetchUsers() {
      this.mxUserFetchErrors = []
      if (!this.mxFetchingUsers) {
        this.mxFetchingUsers = true
        return axios.get('admin/users')
          .then(({ data }) => {
            this.mxUsers = data.index
            this.mxTotalUsers = data.total
          }).catch(errors => {
            this.mxUserFetchErrors = errorHandler(errors)
          }).then(() => {
            this.mxFetchingUsers = false
          })
      }
    },
  },
}

export {
  storeUser,
  updateUser,
  fetchUsers,
}
